import { useEffect, useRef, useState } from "react";
import Question from "./Question";
import moment from "moment";
import { ContextMenu } from "client/CommonComponents";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { activateAssessment, getAllAssessments, setAssessmentActivateSuccess } from "Store/AssetInventory/Assessments/AssessmentAction";
import userProfileSelectors from "../../../../redux/UserProfile/selectors"
import permissions, { isAuthorized } from "client/utils/Permissions";

const QuestionContainer = () =>{
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const { allAssessments, userDetails, assessmentActivated } : any = useSelector((state: any) => ({ 
      allAssessments : state.AssessmentReducer.allAssessmentsList,
      userDetails: userProfileSelectors.getUserDetails(state),
      assessmentActivated: state.AssessmentReducer.assessmentActivated
    }))

    const [gridData, setGridData] = useState<any>([])
    const [showAssessment, setShowAssessment] = useState<boolean>(false)
    const [assessmentData, setAssessmentData] = useState({})
    const [myOrdersearchBoxValue, setMyOrdersearchBoxValue] = useState<string>('')


    useEffect(() => {
      if(userDetails?.permissions?.length && !(isAuthorized(permissions.CreateAssessment) || isAuthorized(permissions.ViewAssessment))){
        navigate('/assetinventory')
      }
    }, [userDetails?.permissions])

    useEffect(()=> {
      dispatch(getAllAssessments())
      setMyOrdersearchBoxValue('')
    }, [])

    useEffect(()=>{
      if(assessmentActivated === 'success'){
        dispatch(getAllAssessments())
      }
    }, [assessmentActivated])

    useEffect(()=>{
      if (allAssessments?.length) {
        const updatedOrderList = allAssessments?.map((item: any) => ({
          ...item,
          orderDate: moment(item.orderDate).format("MM/DD/YYYY"),
          updatedDate: moment(item.updatedDate).format("MM/DD/YYYY")
        }));
        setGridData(updatedOrderList);
      } else {
        setGridData([]);
      }
    }, [JSON.stringify(allAssessments)])

    const onSearchOrder = (e: any, isKeyPressed?: any) => {
      const searchValue = isKeyPressed ? e : e?.target?.value
      setMyOrdersearchBoxValue(searchValue)
      if (searchValue != '') { 
        let filteredList: any[] = [];
        const data = JSON.parse(JSON.stringify(allAssessments))
        if('active'?.includes(searchValue?.toLowerCase())){
          data.forEach((x: any) => {
            if (x?.isActive) {
              filteredList.push({
                ...x,
                orderDate: moment(x.orderDate).format("MM/DD/YYYY"),
                updatedDate: moment(x.updatedDate).format("MM/DD/YYYY")
              });
            }
          });
        } else if('deactive'?.includes(searchValue?.toLowerCase())){
          data.forEach((x: any) => {
            if (!x?.isActive) {
              filteredList.push({
                ...x,
                orderDate: moment(x.orderDate).format("MM/DD/YYYY"),
                updatedDate: moment(x.updatedDate).format("MM/DD/YYYY")
              });
            }
          });
        } else {
          data.forEach((x: any) => {
            if (x.assessmentTitle?.toLowerCase()?.includes(searchValue?.toLowerCase())) {
              filteredList.push({
                ...x,
                orderDate: moment(x.orderDate).format("MM/DD/YYYY"),
                updatedDate: moment(x.updatedDate).format("MM/DD/YYYY")
              });
            }
          });
        }
        setGridData(filteredList)
      } else {
        const updatedOrderList = allAssessments?.map((item: any) => ({
          ...item,
          orderDate: moment(item.orderDate).format("MM/DD/YYYY"),
          updatedDate: moment(item.updatedDate).format("MM/DD/YYYY")
        }));
        setGridData(updatedOrderList);
      }
    }
    
    const CustomCell = (rowData: any) => {
        const [showContextualMenu, setShowContextualMenu] = useState(false);
        const onShowContextualMenu = (ev: React.MouseEvent<HTMLElement>) => {
            ev.preventDefault(); // don't navigate
            setShowContextualMenu(true);
          }

      const menuItems = [
        {
          key: 'View',
          text: 'View',
          disabled: !(isAuthorized(permissions.CreateAssessment) || isAuthorized(permissions.ViewAssessment)),
          onClick: () => {
            setShowAssessment(true)
            setAssessmentData(rowData)
          },
        },
        {
          key: 'Edit',
          text: 'Edit',
          disabled: !(isAuthorized(permissions.CreateAssessment) || isAuthorized(permissions.ViewAssessment)),
          onClick: () => { navigate(`/assetinventory/questions/editassessmentquestion`,{ state: {rowData}}) },
        }
      ]
      
      if (!rowData?.isActive) {
        menuItems.push({
          key: 'Activate',
          text: 'Activate',
          disabled: !isAuthorized(permissions.CreateAssessment),
          onClick: () => {
            dispatch(activateAssessment({...rowData, updatedBy: userDetails?.emailId, updatedDate: null}))
            dispatch(setAssessmentActivateSuccess(''))
          },
        })
      }
      
        const onHideContextualMenu = () => setShowContextualMenu(false);
        const linkRef = useRef(null);
        return (
            <ContextMenu 
                items={menuItems}
                hidden={showContextualMenu}
                target={linkRef}
                onItemClick = {onHideContextualMenu}
                onDismiss = {onHideContextualMenu}
                className='grid-context-menu'   
             data-attribute="Question_container_Default_ContextMenu">          
            <a className="context-menu" ref={linkRef}  href="/assetinventory" onClick={onShowContextualMenu}><span className='fa fa-ellipsis-h'> </span> </a>           
            </ContextMenu>
        )
    }
     
    const handleOrderClearSelectFilter = (search: any, value: any) => {
      search(undefined);
      value.current = "";
    };
    
    const CreateNewAssessmentClick = () =>{
      navigate('createnewassessment')
    }

    const hidePopup = () => {
      setShowAssessment(false)
    }

    useEffect(() => {
      document.getElementsByClassName('content-wrapper')[0].scrollTop = 0;
    }, []);

    return <Question 
        CreateNewAssessmentClick={CreateNewAssessmentClick}
        CustomCell={CustomCell}
        handleOrderClearSelectFilter={handleOrderClearSelectFilter}
        allAssessments={gridData}
        showAssessment={showAssessment}
        hidePopup={hidePopup}
        assessmentData={assessmentData}
        onSearchOrder={onSearchOrder}
        myOrdersearchBoxValue={myOrdersearchBoxValue}
    />
}

export default QuestionContainer;